export default __webpack_public_path__ + "static/media/free samoohika seva.f25409a5.jpg";